import { createAction, props } from '@ngrx/store';

import { PlayerStatistics } from './player-statistics.model';

export const loadPlayerStatisticsData = createAction(
    '[Player Statistics] Load Player Statistics Data',
    props<{ eventId: string; marketFilter: string; mainMarket: boolean }>(),
);

export const playerStatisticsDataSuccess = createAction(
    '[Player Statistics] Player Statistics Data Success',
    props<{
        eventId: string;
        marketFilter: string;
        mainMarket: boolean;
        data: PlayerStatistics | undefined;
        isLoading: boolean;
        isError: boolean;
    }>(),
);

export const playerStatisticsDataFailure = createAction(
    '[Player Statistics] Player Statistics Data Failure',
    props<{
        eventId: string;
        marketFilter: string;
        mainMarket: boolean;
        data: PlayerStatistics | undefined;
        isLoading: boolean;
        isError: boolean;
    }>(),
);

export const resetPlayerStatisticsState = createAction('[Player Statistics] reset Player Statistics state');

export const setPlayerStatisticsOpenAndTrackingStatus = createAction(
    '[Player Statistics] Set Open And Tracking Status',
    props<{
        eventId: string;
        marketFilter: string;
        mainMarket: boolean;
        playerName: string;
        marketId: string;
        isOpen?: boolean;
        tracking?: boolean;
    }>(),
);
